import { Container } from "@/components/ui/Container";
import { Section } from "@/components/ui/Section";
import { SectionHeading } from "@/components/ui/SectionHeading";
import { IconCardGrid } from "@/components/sections/IconCardGrid";
import { WHO_WE_SERVE } from "@/data/content";

export function WhoWeServe() {
  return (
    <Section id="who-we-serve" muted data-testid="who-we-serve-section">
      <Container>
        <SectionHeading
          eyebrow="Who We Serve"
          title="Support across the clinical research ecosystem"
          description="We connect suitable study opportunities with capable clinical sites, and support every partner along the way."
        />
        <div className="mt-12">
          <IconCardGrid items={WHO_WE_SERVE} columns={3} tone="emerald" cardTestId="who-we-serve-card" />
        </div>
      </Container>
    </Section>
  );
}
